import React from 'react';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import CircularProgress from '@mui/material/CircularProgress';

const SelectFormField = ({
  input,
  required,
  label,
  meta: { touched, error },
  children,
  multiple,
  fullWidth,
  loading,
  ...custom
}) => {
  return (
    <FormControl variant='standard' fullWidth={fullWidth} required={required}>
      <InputLabel error={touched && Boolean(error)} htmlFor={label}>
        {label}
      </InputLabel>
      <Select
        IconComponent={
          loading
            ? () => (
                <CircularProgress
                  variant='indeterminate'
                  size={16}
                  thickness={4}
                />
              )
            : undefined
        }
        multiple={multiple}
        error={touched && Boolean(error)}
        disabled={loading}
        variant='standard'
        {...input}
        {...custom}
      >
        {children}
      </Select>
      {touched && Boolean(error) && (
        <FormHelperText error>{error}</FormHelperText>
      )}
    </FormControl>
  );
};

export default SelectFormField;
